import { Modal, Button } from 'react-bootstrap';

const tryFormatJson = (txt) => {
  if (!txt) return '';
  try { return JSON.stringify(JSON.parse(txt), null, 2); }
  catch { return txt; }
};

const LogsDetailsModal = ({ show, onHide, log }) => {
  const pretty = tryFormatJson(log?.detalles);
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Log details #{log?.id}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2"><strong>Tipo:</strong> {log?.tipo}</div>
        <div className="mb-2"><strong>Objeto:</strong> {log?.objeto}</div>
        <div className="mb-2"><strong>Resultado:</strong> {log?.resultado}</div>
        <div className="mb-2"><strong>Fecha (UTC):</strong> {new Date(log?.fecha).toLocaleString()}</div>
        <pre className="bg-light p-3 rounded" style={{ maxHeight: 400, overflow: 'auto' }}>
{pretty}
        </pre>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogsDetailsModal;
